import { useContext, useEffect } from 'react';
import TitleContext from './TitleContext';

/**
 * @param {string | import('./TitleContext').TitleObject} title
 */
export default function useTitle(title) {
    const { title: current, register } = useContext(TitleContext);

    useEffect(() => {
        if (!title) return;

        const unregister = register(title);

        return () => unregister();
    }, [title]);

    return current;
}